import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type JoyFeatureCurrencyConversionQueryVariables = Types.Exact<{
  currencyCode: Types.Scalars['String'];
}>;

export type JoyFeatureCurrencyConversionQuery = {
  __typename?: 'Query';
  currencyConversionByCode: {
    __typename?: 'CurrencyConversion';
    currencyCode: string;
    exchangeRate: number;
    taxesAndFeesMultiplier: number;
    precision: number;
    fixedCostPerCardInMinorUnits: number;
  };
};

export const JoyFeatureCurrencyConversionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JoyFeatureCurrencyConversion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currencyCode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currencyConversionByCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currencyCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currencyCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exchangeRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxesAndFeesMultiplier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'precision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fixedCostPerCardInMinorUnits' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useJoyFeatureCurrencyConversionQuery__
 *
 * To run a query within a React component, call `useJoyFeatureCurrencyConversionQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyFeatureCurrencyConversionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyFeatureCurrencyConversionQuery({
 *   variables: {
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useJoyFeatureCurrencyConversionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<JoyFeatureCurrencyConversionQuery, JoyFeatureCurrencyConversionQueryVariables>,
) {
  return ApolloReactHooks.useQuery<JoyFeatureCurrencyConversionQuery, JoyFeatureCurrencyConversionQueryVariables>(JoyFeatureCurrencyConversionDocument, baseOptions);
}
export function useJoyFeatureCurrencyConversionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyFeatureCurrencyConversionQuery, JoyFeatureCurrencyConversionQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<JoyFeatureCurrencyConversionQuery, JoyFeatureCurrencyConversionQueryVariables>(JoyFeatureCurrencyConversionDocument, baseOptions);
}
export type JoyFeatureCurrencyConversionQueryHookResult = ReturnType<typeof useJoyFeatureCurrencyConversionQuery>;
export type JoyFeatureCurrencyConversionLazyQueryHookResult = ReturnType<typeof useJoyFeatureCurrencyConversionLazyQuery>;
export type JoyFeatureCurrencyConversionQueryResult = Apollo.QueryResult<JoyFeatureCurrencyConversionQuery, JoyFeatureCurrencyConversionQueryVariables>;
